module.exports = __webpack_public_path__ + "static/media/companies.dd797e2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies.svg
// module id = 599
// module chunks = 0